import { render, staticRenderFns } from "./itemimple.vue?vue&type=template&id=b0f7156a&scoped=true&"
import script from "./itemimple.vue?vue&type=script&lang=js&"
export * from "./itemimple.vue?vue&type=script&lang=js&"
import style0 from "./itemimple.vue?vue&type=style&index=0&id=b0f7156a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f7156a",
  null
  
)

export default component.exports